import { Badge } from 'react-bootstrap';
import { IWorkerData } from '@th-types/worker.type';
import './style.css';
import { containsInNetworkBadge } from '@utils/Person';

interface Params {
  worker: IWorkerData;
  showSmall?: boolean;
  addClass?: string;
  badgeText: string;
}

export default function ThWorkerBadge({
  worker,
  showSmall,
  addClass,
  badgeText,
}: Params) {
  const classNames = (): string => {
    let classesToAdd = 'mx-1 text-dark';
    if (addClass) {
      classesToAdd = `${classesToAdd} ${addClass}`;
    }
    return classesToAdd;
  };

  if (containsInNetworkBadge(worker)) {
    return showSmall ? (
      <small>
        <Badge className={classNames()} bg="primary">
          {badgeText}
        </Badge>
      </small>
    ) : (
      <Badge className={classNames()} bg="primary">
        {badgeText}
      </Badge>
    );
  }

  return <div />;
}
